import _extends from "@babel/runtime/helpers/esm/extends";
// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY

import * as React from 'react';
import ClockCircleFilledSvg from "@ant-design/icons-svg/es/asn/ClockCircleFilled";
import AntdIcon from "../components/AntdIcon";
var ClockCircleFilled = function ClockCircleFilled(props, ref) {
  return /*#__PURE__*/React.createElement(AntdIcon, _extends({}, props, {
    ref: ref,
    icon: ClockCircleFilledSvg
  }));
};
if (process.env.NODE_ENV !== 'production') {
  ClockCircleFilled.displayName = 'ClockCircleFilled';
}
export default /*#__PURE__*/React.forwardRef(ClockCircleFilled);